import(/* webpackMode: "eager", webpackExports: ["LandingPage"] */ "/vercel/path0/apps/web/src/components/landing/LandingPage.tsx");
